import { Icon } from "@iconify/react";
import { Fragment, useEffect, useState } from "react";
import plusFill from "@iconify/icons-eva/plus-fill";
import iconEdit from "@iconify/icons-eva/edit-2-fill";
import iconDelete from "@iconify/icons-eva/person-delete-fill";
import { Link, useNavigate } from "react-router-dom";
import moment from "moment";
// material
import { Card, Table, Stack, Switch, Button, TextField, TableRow, TableBody, TableCell, Container, Typography, TableContainer, RadioGroup, Radio, FormControlLabel, IconButton } from "@mui/material";
// components
import Page from "src/components/Page";
import Scrollbar from "src/components/Scrollbar";
import SearchNotFound from "src/components/SearchNotFound";

import MoreMenu from "src/components/common/MoreMenu";
import FormDialog from "src/components/common/FormDialog";
import FormItem from "src/components/form-item/FormItem";
import Confirm from "src/components/common/ConfirmDialog";
import { ArrowRight } from "@mui/icons-material";
import ListHead from "src/components/common/ListHead";
import { useSelector } from "react-redux";
import { asyncRequest } from "src/services/network";
import TreeSelect from "src/components/lib/tree-select/TreeSelect";
import { alert } from "src/services/alert";

const TABLE_HEAD = [
  { id: "uid", label: "组织名称", alignRight: false },
  { id: "order", label: "排序", alignRight: false },
  { id: "isShow", label: "是否显示", alignRight: false },
  { id: "createdAt", label: "创建时间", alignRight: false },
  { id: "operation" }
];

const moreMenus = [
  { title: "添加子组织", icon: plusFill },
  { title: "编辑", icon: iconEdit },
  { title: "删除", icon: iconDelete },
];

function CategoryForm({ pid, row, data, action, onClose, onConfirm }) {
  const [form, setForm] = useState({
    icon: row.icon || "",
    name: row.name || "",
    order: row.order || 0,
    isShow: row.isShow !== undefined ? row.isShow : true,
    pid: row.pid || pid || 0,
  });

  useEffect(() => {
    setForm({
      icon: row.icon || "",
      name: row.name || "",
      order: row.order || 0,
      isShow: row.isShow !== undefined ? row.isShow : true,
      pid: row.pid || pid || 0,
    })
  }, [row])

  function handleIptChange(ki, val) {
    setForm({
      ...form,
      [ki]: val,
    });
  }

  function handleConfirm() {
    onConfirm(form);
  }

  return (
    <FormDialog title={action === "add" ? "添加组织" : "修改组织"} open={!!action} onClose={onClose} onConfirm={handleConfirm}>
      <FormItem title="父级组织">
        <TreeSelect
          data={data}
          value={form.pid}
          maxLevel={action === "add" ? row.level : row.level - 1}
          onChange={v => handleIptChange("pid", v)}
          topLabel="顶级菜单"
        />
      </FormItem>

      <FormItem title="名称" required>
        <TextField fullWidth placeholder="名称" autoComplete="off" id="name" value={form.name} size="small" onChange={(e) => handleIptChange("name", e.target.value)} />
      </FormItem>

      <FormItem title="排序" required>
        <TextField fullWidth placeholder="排序" type="number" autoComplete="off" id="order" value={form.order} size="small" onChange={(e) => handleIptChange("order", e.target.value)} />
      </FormItem>

      <FormItem title="状态" required>
        <Switch checked={form.isShow} onChange={(e) => handleIptChange("isShow", e.target.checked)} />
      </FormItem>
    </FormDialog>
  );
}

const MAX_LEVEL = 6;

export default function Orgs() {
  const navigate = useNavigate();
  const [foldMap, setFoldMap] = useState({});

  const [action, setAction] = useState("");
  const [targetItem, setTargetItem] = useState({});
  const [pid, setPid] = useState(0);

  const [categoryTree, setCategoryTree] = useState([]);

  useEffect(() => {
    getCategories(true);
  }, []);

  async function getCategories() {
    const { data } = await asyncRequest({
      method: "get",
      path: "/user/org/all",
    });

    setCategoryTree(data);
  }

  function handleAddMenu(pid = 0, pName = "顶级组织") {
    setTargetItem({});
    setAction("add");
  }

  const handleMoreClick = (type, row) => {
    if (type === "编辑") {
      setPid(row.pid);
      setTargetItem({ ...row });
      setAction("edit");
    } else if (type === "删除") {
      handleDelBanner(row.id);
    } else if (type === "添加子组织") {
      if (row.level >= MAX_LEVEL) return alert('不能再细分了');
      setPid(row.id);
      handleAddMenu(row.id, row.name);
    }
  };

  function handleDelBanner(id) {
    Confirm({
      message: "删除不可恢复，确定删除吗?",
      async onConfirm() {
        await asyncRequest({
          path: "/user/org/del",
          data: { id },
        });

        getCategories(true);
      },
    });
  }

  async function handleDialogConfirm(form) {
    const formData = { ...form };

    if (action === "edit") {
      formData.id = targetItem.id;
    }

    await asyncRequest({
      path: action === "add" ? "/user/org/add" : "/user/org/edit",
      data: formData,
    });

    getCategories(true);
    setTargetItem({});
    setPid(0);
    setAction("");
  }

  async function toggleShow(id, to) {
    await asyncRequest({
      path: "/user/org/toggleShow",
      data: {
        id,
        isShow: to,
      },
    });

    getCategories(true);
  }

  function handleFolding(row) {
    // console.log(row.pid, row.name, foldMap);
    setFoldMap({
      ...foldMap,
      [row.id]: !foldMap[row.id],
    });
  }

  const isUserNotFound = categoryTree.length === 0;

  function renderTableRow(list, visible = true) {
    if (!list) return null;
    return list.map((row) => {
      const { id, name, icon, isShow, createdAt, order, level, pid, children } = row;

      const hasChildren = !!children && children.length > 0;

      if (visible) {
        visible = foldMap[pid];
      }

      let display = "none";
      if (level === 1 || visible) {
        display = "";
      }

      return (
        <Fragment key={id}>
          <TableRow hover key={id} tabIndex={-1} role="checkbox" sx={{ display }}>
            <TableCell align="left" sx={{ pl: level - 1 }}>
              <IconButton onClick={() => handleFolding(row)} disabled={!hasChildren}>
                <ArrowRight sx={{ visibility: !hasChildren ? "hidden" : "visible", transform: `rotate(${foldMap[id] ? 90 : 0}deg)` }} />
              </IconButton>
              {name}
            </TableCell>
            <TableCell align="left">{order}</TableCell>
            <TableCell align="left">
              <Switch checked={isShow} onChange={(e) => toggleShow(id, e.target.checked)} />
            </TableCell>
            <TableCell align="left">{moment(createdAt).format("YYYY-MM-DD HH:mm:ss")}</TableCell>
            <TableCell align="right">
              <MoreMenu spread menus={moreMenus} onMoreClick={(type) => handleMoreClick(type, row)} />
            </TableCell>
          </TableRow>
          {renderTableRow(children, visible)}
        </Fragment>
      );
    });
  }

  return (
    <Page title="组织列表">
      <Container maxWidth="2000px">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            组织列表
          </Typography>

          <Button variant="contained" to="add" startIcon={<Icon icon={plusFill} />} onClick={() => handleAddMenu()}>
            添加组织
          </Button>
        </Stack>

        <Card>
          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <ListHead headLabel={TABLE_HEAD} rowCount={categoryTree.length} />

                <TableBody>{renderTableRow(categoryTree)}</TableBody>
                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        {/* <SearchNotFound searchQuery={filterName} /> */}
                        <SearchNotFound />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>
        </Card>
      </Container>

      <CategoryForm
        data={categoryTree}
        action={action}
        row={targetItem}
        pid={pid}
        onClose={() => setAction()}
        onConfirm={handleDialogConfirm}
      />
    </Page>
  );
}
